import { FC } from "react";
import Text from "../../../../../components/Text";

import { CustomDayCellProps } from "..";

import styles from "./styles.module.scss";

const DefaultDay: FC<CustomDayCellProps> = (props) => {
    const {
        onEmptyWeekdayClick,
        isEmptyCalendarDayAddAllowed: _omitPred,
        hidePerformance: _omitHidePerformance,
        day,
        ...rest
    } = props;

    return (
        <div
            {...rest}
            className={`${rest.className ?? ""} ${
                onEmptyWeekdayClick ? styles.clickableEmptyDay : ""
            }`.trim()}
            onClick={
                onEmptyWeekdayClick
                    ? (e) => {
                          e.stopPropagation();
                          onEmptyWeekdayClick(day.date);
                      }
                    : undefined
            }
            role={onEmptyWeekdayClick ? "button" : undefined}
        >
            <div className={styles.customDayCellContent}>
                <Text className={styles.dayNumber} variant="body">
                    {props.day.date.getDate()}
                </Text>
            </div>
        </div>
    );
};

export default DefaultDay;
